import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import { StoresContext } from '@App/contexts'
import ContentHeader from '@Components/ContentHeader'
import WorkMergeHeader from '@Scenes/RightsholderScene/WorkMerge/WorkMergeHeader'
import WorkMergeSearch from '@Scenes/RightsholderScene/WorkMerge/WorkMergeSearch'
import '@Scenes/RightsholderScene/WorkMerge/index.scss'

const WorkMergeNewRequest = () => {
    const { catalogSearchBulkActionStore } = useContext(StoresContext)

    return (
        <div className="work-merge-wrapper">
            {catalogSearchBulkActionStore.isReviewingRequest ? (
                <ContentHeader title="Work Merge Request Tool" />
            ) : (
                <WorkMergeHeader />
            )}
            <WorkMergeSearch />
        </div>
    )
}

export default observer(WorkMergeNewRequest)
